import { jsx as _jsx } from "react/jsx-runtime";
import * as S from './BottomDrawer.styles';
export function BottomDrawer({ children, maxWidth }) {
    return (_jsx(S.BottomDrawer, { children: _jsx(S.DrawerContent, Object.assign({ "$maxWidth": maxWidth }, { children: children })) }));
}
